// Mobile menu toggle functionality
(function() {
  'use strict';
  
  // Wait for DOM to be fully loaded
  function initMobileMenu() {
    const menuButton = document.getElementById('mobile-menu-button');
    const mobileMenu = document.getElementById('mobile-menu');
    const openIcon = document.getElementById('menu-open-icon');
    const closeIcon = document.getElementById('menu-close-icon');
    
    if (!menuButton || !mobileMenu || !openIcon || !closeIcon) {
      console.warn('Mobile menu elements not found');
      return;
    }
    
    // Toggle menu function
    function toggleMenu(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      
      const isExpanded = menuButton.getAttribute('aria-expanded') === 'true';
      
      // Toggle menu visibility
      mobileMenu.classList.toggle('hidden');
      
      // Toggle icons
      openIcon.classList.toggle('hidden');
      closeIcon.classList.toggle('hidden');
      
      // Update aria-expanded
      menuButton.setAttribute('aria-expanded', !isExpanded);
      
      // Prevent body scroll when menu is open
      if (!isExpanded) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
    
    // Close menu function
    function closeMenu() {
      mobileMenu.classList.add('hidden');
      openIcon.classList.remove('hidden');
      closeIcon.classList.add('hidden');
      menuButton.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    
    // Add both click and touchend events for better mobile support
    menuButton.addEventListener('click', toggleMenu);
    
    // Additional touch support
    menuButton.addEventListener('touchend', function(e) {
      e.preventDefault();
      toggleMenu(e);
    }, { passive: false });
    
    // Close menu when clicking on a link
    const menuLinks = mobileMenu.querySelectorAll('a');
    menuLinks.forEach(link => {
      link.addEventListener('click', closeMenu);
      link.addEventListener('touchend', function(e) {
        // Let the link click through but close the menu
        setTimeout(closeMenu, 100);
      });
    });
    
    // Close menu when clicking outside
    document.addEventListener('click', function(e) {
      if (!menuButton.contains(e.target) && !mobileMenu.contains(e.target)) {
        if (!mobileMenu.classList.contains('hidden')) {
          closeMenu();
        }
      }
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenu);
  } else {
    initMobileMenu();
  }
})();
